import { SettingsParser } from "../../settings-parser";
import { SignalPlotSettings } from "../../../settings/view-objects/plot/signal-plot-settings";
import { ColorConverter, ObjectCreator } from "../../../../../../../web-graphics";

export class SignalPlotSettingsParser extends SettingsParser {
  constructor() {
    super();
    this.parsedFieldNames = ["id_signal", "id_isoline", "color", "type", "fillType", "pointCount"];
  }

  static createSettings(settings, defaultSettings) {
    if (settings === undefined) {
      return undefined;
    }
    let signalType = ObjectCreator.merge(settings.type, defaultSettings?.type);
    if (signalType === undefined) {
      signalType = "line";
    }
    let fillType = ObjectCreator.merge(settings.fillType, defaultSettings?.fillType);
    if (fillType === undefined) {
      fillType = "custom";
    }
    let pointCount = undefined;
    if (fillType == "custom") {
      pointCount = ObjectCreator.merge(settings.pointCount, defaultSettings?.pointCount);
      if (pointCount === undefined) {
        pointCount = 2;
      }
    }
    const parsedColorText = ObjectCreator.merge(settings.color, defaultSettings?.color);
    const colorParsingResult = ColorConverter.convertToWebglRgba(parsedColorText);
    const parsedSettings = {
      type: signalType,
      id_signal: settings.id_signal,
      id_isoline: settings.id_isoline,
      color: colorParsingResult.value,
      fillType: fillType,
      pointCount: pointCount
    };
    return parsedSettings;
  }

  parse(settings, defaultSettings) {
    let parsedSettings = SignalPlotSettingsParser.createSettings(settings, defaultSettings);
    if (parsedSettings === undefined) {
      return undefined;
    }
    SettingsParser.parseRestFields(settings, defaultSettings, this.parsedFieldNames, parsedSettings);
    return new SignalPlotSettings(parsedSettings);
  }
}
